import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-6">
      <div className="w-full max-w-md rp-card-lg text-center">
        <h1 className="mb-2 font-display text-[28px] font-extrabold text-navy">404</h1>
        <p className="mb-4 text-[13.5px] text-text2">Az oldal nem található.</p>
        <Link to="/overview" className="rp-btn-primary inline-flex">
          Vissza az áttekintéshez
        </Link>
      </div>
    </div>
  )
}
